import { getDictionary } from '@synisys/dictionary';
import { SUPPORTED_ICONS } from './supported-icons';
import { applySearchAndReturnSortInfo, } from '../context-menu/item-search-sort';
export class IconMetadata {
    constructor(identifier, size, translationKey, displayName) {
        this.identifier = identifier;
        this.size = size;
        this.translationKey = translationKey;
        this.displayName = displayName;
        this.getSecondaryField = () => undefined;
    }
    getPrimaryField() {
        return this.displayName;
    }
    applySearchAndReturnSortInfo(searchFilter) {
        return applySearchAndReturnSortInfo(this, searchFilter);
    }
}
export const SUPPORTED_ICONS_METADATA = {
    8: SUPPORTED_ICONS['8'].map(identifier => ({ identifier, size: 8 })),
    16: SUPPORTED_ICONS['16'].map(identifier => ({ identifier, size: 16 })),
    24: SUPPORTED_ICONS['24'].map(identifier => ({ identifier, size: 24 })),
};
export function getSupportedIconsMetadata(size) {
    return SUPPORTED_ICONS_METADATA[size].map(icon => decorateIconWithDisplayName(icon));
}
export function decorateIconWithDisplayName(icon, translate) {
    const translationKey = resolveIconTranslationKey(icon.identifier);
    const translatedDisplayName = translate
        ? translate(translationKey)
        : getDictionary().translate(translationKey);
    // if (isNil(translatedDisplayName) || translatedDisplayName.length === 0) {
    //     translatedDisplayName = generateDisplayNameFromIdentifier(icon.identifier);
    // }
    return new IconMetadata(icon.identifier, icon.size, translationKey, translatedDisplayName);
}
export function resolveIconTranslationKey(icon) {
    return `sds.icon.${icon}`;
}
export function generateDisplayNameFromIdentifier(iconIdentifier) {
    return iconIdentifier
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}
